/* CPH Luggage Premium: filtre, sortering, "vis flere" og grid-vælger på kollektion og søgning. Plutonic, 2026-09-30.
   Bygger på Shopifys egen filtrering. Resultater hentes med Section Rendering API (section_id) og skiftes ud uden
   genindlæsning; URL'en opdateres, så tilbage-knappen og deling virker. */
(function () {
  'use strict';
  function q(s, c) { return (c || document).querySelector(s); }
  function qa(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  var mq = window.matchMedia('(max-width: 1023px)');
  var GRID_KEY = 'cphl-grid';

  function Facets(root) {
    this.root = root;
    this.section = root.getAttribute('data-section');
    this.form = q('[data-facets-form]', root);
    this.ctrl = null;
    this.bind();
    this.syncSets();
    this.initPrice();
    this.initGrid();
  }

  Facets.prototype.set = function () { return mq.matches ? 'm' : 'd'; };

  /* Kun det synlige sæt felter sendes med: panelerne på computer, arket på mobil */
  Facets.prototype.syncSets = function () {
    var s = this.set();
    qa('[data-set]', this.form).forEach(function (el) {
      if (el.dataset.dis === undefined) el.dataset.dis = el.disabled ? '1' : '0';
      el.disabled = el.dataset.dis === '1' || el.getAttribute('data-set') !== s;
      if (el.dataset.dis === '1' && el.checked) el.disabled = el.getAttribute('data-set') !== s;
    });
    var sel = q('[data-facets-sort]', this.form);
    if (sel) sel.disabled = s === 'm';
  };

  Facets.prototype.url = function () {
    var fd = new FormData(this.form);
    var p = new URLSearchParams();
    fd.forEach(function (v, k) {
      if (v === '' || v === null) return;
      if (k === 'sort_by_m') k = 'sort_by';
      p.append(k, v);
    });
    var base = this.form.getAttribute('action') || window.location.pathname;
    var s = p.toString();
    return base + (s ? '?' + s : '');
  };

  Facets.prototype.withSection = function (u) {
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(this.section);
  };

  Facets.prototype.apply = function (u, push) {
    var self = this;
    if (this.ctrl) this.ctrl.abort();
    this.ctrl = 'AbortController' in window ? new AbortController() : null;
    document.documentElement.classList.add('cphl-fx-loading');
    fetch(this.withSection(u), this.ctrl ? { signal: this.ctrl.signal } : {})
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        self.render(doc);
        if (push !== false && window.history && history.pushState) history.pushState({ cphlFacets: 1 }, '', u);
      })
      .catch(function (e) { if (e && e.name === 'AbortError') return; window.location.href = u; })
      .then(function () { document.documentElement.classList.remove('cphl-fx-loading'); });
  };

  Facets.prototype.render = function (doc) {
    var root = this.root;
    var nroot = q('[data-facets]', doc);
    var results = q('[data-facets-results]');
    var nresults = q('[data-facets-results]', doc);
    if (results && nresults) { results.innerHTML = nresults.innerHTML; this.applyGrid(); }
    if (!nroot) return;
    // Filterknapper: behold et åbent panel åbent
    var open = qa('[data-pill]', root).map(function (p) { return p.classList.contains('is-open'); });
    var pills = q('[data-facets-pills]', root), npills = q('[data-facets-pills]', nroot);
    if (pills && npills) {
      pills.innerHTML = npills.innerHTML;
      qa('[data-pill]', pills).forEach(function (p, i) { if (open[i]) { p.classList.add('is-open'); q('[data-pill-btn]', p).setAttribute('aria-expanded', 'true'); } });
    }
    // Arket: behold åbne grupper og scroll
    var body = q('.cphl-fx__sheetbody', root), nbody = q('.cphl-fx__sheetbody', nroot);
    if (body && nbody) {
      var st = body.scrollTop;
      var det = qa('details', body).map(function (d) { return d.open; });
      body.innerHTML = nbody.innerHTML;
      qa('details', body).forEach(function (d, i) { if (det[i] !== undefined) d.open = det[i]; });
      body.scrollTop = st;
    }
    ['[data-facets-chips]', '[data-facets-count]', '[data-facets-show]'].forEach(function (s) {
      var a = q(s, root), b = q(s, nroot);
      if (a && b) { a.innerHTML = b.innerHTML; a.hidden = b.hidden; }
    });
    var bad = q('[data-facets-badge]', root), nbad = q('[data-facets-badge]', nroot);
    if (bad && nbad) { bad.textContent = nbad.textContent; bad.hidden = nbad.hidden; }
    var sel = q('[data-facets-sort]', root), nsel = q('[data-facets-sort]', nroot);
    if (sel && nsel) sel.value = nsel.value;
    this.syncSets();
    this.initPrice();
    document.dispatchEvent(new CustomEvent('cphl:facets-updated'));
  };

  Facets.prototype.initPrice = function () {
    qa('[data-price]', this.form).forEach(function (box) {
      if (box.dataset.ready) return;
      box.dataset.ready = '1';
      var max = parseFloat(box.getAttribute('data-max')) || 0;
      var lo = q('[data-price-lo]', box), hi = q('[data-price-hi]', box);
      var mn = q('[data-price-min]', box), mx = q('[data-price-max]', box);
      var fill = q('[data-price-fill]', box);
      function paint() {
        var a = +lo.value, b = +hi.value;
        if (fill && max) { fill.style.left = (a / max * 100) + '%'; fill.style.right = (100 - b / max * 100) + '%'; }
      }
      lo.addEventListener('input', function () { if (+lo.value > +hi.value - 10) lo.value = +hi.value - 10; mn.value = +lo.value > 0 ? lo.value : ''; paint(); });
      hi.addEventListener('input', function () { if (+hi.value < +lo.value + 10) hi.value = +lo.value + 10; mx.value = +hi.value < max ? hi.value : ''; paint(); });
      [mn, mx].forEach(function (inp) {
        inp.addEventListener('input', function () {
          if (inp === mn) lo.value = inp.value || 0; else hi.value = inp.value || max;
          paint();
        });
      });
      paint();
    });
  };

  Facets.prototype.initGrid = function () {
    var self = this;
    qa('[data-grid]', this.root).forEach(function (b) {
      b.addEventListener('click', function () {
        var n = b.getAttribute('data-grid');
        var key = GRID_KEY + (+n <= 2 ? '-m' : '-d');
        try { localStorage.setItem(key, n); } catch (e) { /* privat vindue */ }
        self.applyGrid();
      });
    });
    this.applyGrid();
  };

  Facets.prototype.applyGrid = function () {
    var m = '2', d = '4';
    try { m = localStorage.getItem(GRID_KEY + '-m') || m; d = localStorage.getItem(GRID_KEY + '-d') || d; } catch (e) { /* ingen lager */ }
    qa('[data-facets-grid]').forEach(function (g) { g.style.setProperty('--cphl-gm', m); g.style.setProperty('--cphl-gd', d); });
    qa('[data-grid]', this.root).forEach(function (b) {
      var n = b.getAttribute('data-grid');
      b.classList.toggle('is-on', n === m || n === d);
      b.setAttribute('aria-pressed', n === m || n === d ? 'true' : 'false');
    });
  };

  Facets.prototype.closePills = function (except) {
    qa('[data-pill]', this.root).forEach(function (p) {
      if (p === except) return;
      p.classList.remove('is-open');
      var b = q('[data-pill-btn]', p);
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  };

  Facets.prototype.openSheet = function () {
    var sh = q('[data-facets-sheet]', this.root);
    if (!sh) return;
    this.lastFocus = document.activeElement;
    sh.classList.add('is-open');
    document.documentElement.classList.add('cphl-lock');
    var b = q('[data-facets-open]', this.root);
    if (b) b.setAttribute('aria-expanded', 'true');
    setTimeout(function () { var x = q('.cphl-fx__x', sh); if (x) x.focus({ preventScroll: true }); }, 60);
  };
  Facets.prototype.closeSheet = function () {
    var sh = q('[data-facets-sheet]', this.root);
    if (!sh || !sh.classList.contains('is-open')) return;
    sh.classList.remove('is-open');
    document.documentElement.classList.remove('cphl-lock');
    var b = q('[data-facets-open]', this.root);
    if (b) b.setAttribute('aria-expanded', 'false');
    if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus({ preventScroll: true });
  };

  Facets.prototype.bind = function () {
    var self = this, root = this.root, form = this.form;
    var t = null;
    function later() { clearTimeout(t); t = setTimeout(function () { self.apply(self.url()); }, 250); }
    form.addEventListener('change', function (e) {
      var el = e.target;
      if (el.matches('[data-price-lo], [data-price-hi]')) { later(); return; }
      if (el.matches('input, select')) later();
    });
    form.addEventListener('submit', function (e) { e.preventDefault(); self.apply(self.url()); });
    root.addEventListener('click', function (e) {
      var link = e.target.closest('[data-facets-link]');
      if (link) { e.preventDefault(); self.apply(link.href); return; }
      var pb = e.target.closest('[data-pill-btn]');
      if (pb) {
        var pill = pb.closest('[data-pill]');
        var on = !pill.classList.contains('is-open');
        self.closePills(pill);
        pill.classList.toggle('is-open', on);
        pb.setAttribute('aria-expanded', on ? 'true' : 'false');
        return;
      }
      if (e.target.closest('[data-pill-close]')) { self.closePills(); return; }
      if (e.target.closest('[data-facets-open]')) { self.openSheet(); return; }
      if (e.target.closest('[data-facets-close]')) { self.closeSheet(); return; }
      if (e.target.matches('[data-facets-sheet]')) self.closeSheet();
    });
    document.addEventListener('click', function (e) { if (!e.target.closest('[data-pill]')) self.closePills(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { self.closePills(); self.closeSheet(); } });
    if (mq.addEventListener) mq.addEventListener('change', function () { self.syncSets(); if (!mq.matches) self.closeSheet(); });
    window.addEventListener('popstate', function () { self.apply(window.location.href, false); });

    /* Vis flere: næste side hentes og kortene lægges i forlængelse */
    document.addEventListener('click', function (e) {
      var more = e.target.closest('[data-load-more]');
      if (!more || more.classList.contains('is-loading')) return;
      e.preventDefault();
      more.classList.add('is-loading');
      fetch(self.withSection(more.href))
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var grid = q('[data-facets-grid]'), ngrid = q('[data-facets-grid]', doc);
          if (grid && ngrid) qa(':scope > li', ngrid).forEach(function (li) { grid.appendChild(li); });
          var foot = q('[data-facets-more]'), nfoot = q('[data-facets-more]', doc);
          if (foot) foot.innerHTML = nfoot ? nfoot.innerHTML : '';
          document.dispatchEvent(new CustomEvent('cphl:facets-updated'));
        })
        .catch(function () { window.location.href = more.href; });
    });
  };

  function boot(scope) {
    qa('[data-facets]', scope || document).forEach(function (el) {
      if (el.dataset.ready) return;
      el.dataset.ready = '1';
      new Facets(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
